import React, { useState } from 'react';
import { Box, Button, Checkbox, createStyles, FormControlLabel, makeStyles, MenuItem, TextField, Typography, } from '@material-ui/core';
import { ConfirmDeleteEventChainLink } from '../ConfirmDeleteEventChainLink';
import { useCreateEventChainLink } from '../../services/hooks/use-create-event-chain-link';
import { useDeleteEventChainLink } from '../../services/hooks/use-delete-event-chain-link';
import { useGetChainDescriptions } from '../../services/hooks/use-get-chain-descriptions';
import { useUpdateEventChainLink } from '../../services/hooks/use-update-event-chain-link';
const useStyles = makeStyles(() => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '800px',
        padding: '72px',
    },
    header: {
        fontWeight: 600,
        marginBottom: '32px',
    },
    input: {
        width: '370px',
        marginBottom: '16px',
    },
}));
export const FormEventChainLink = ({ isEditing = false, initialState, onSubmit }) => {
    const styles = useStyles();
    const initialEventCode = initialState?.eventCode ?? '';
    const initialDescription = initialState?.eventLinkDescription ?? '';
    const initialChainTypeGuid = initialState?.chainTypeGuid ?? '';
    const initialEnabled = initialState?.enabled ?? true;
    const [eventCode, setEventCode] = useState(initialEventCode);
    const [description, setDescription] = useState(initialDescription);
    const [chainTypeGuid, setChainTypeGuid] = useState(initialChainTypeGuid);
    const [enabled, setEnabled] = useState(initialEnabled);
    const { data: chainsList } = useGetChainDescriptions();
    const chainDescriptions = chainsList?.chainDescriptions ?? [];
    const { mutate: updateLink, isLoading: isUpdating } = useUpdateEventChainLink(onSubmit);
    const { mutate: createLink, isLoading: isCreating } = useCreateEventChainLink(onSubmit);
    const { mutate: deleteLink, isLoading: isDeleting } = useDeleteEventChainLink(onSubmit);
    const isLoading = isUpdating || isCreating || isDeleting;
    const trimmedEventCode = eventCode.trim();
    const trimmedDescription = description.trim();
    const isFilled = trimmedEventCode !== '' && chainTypeGuid !== '';
    const isSomethingChanged = trimmedEventCode !== initialEventCode ||
        trimmedDescription !== initialDescription ||
        chainTypeGuid !== initialChainTypeGuid ||
        enabled !== initialEnabled;
    const canSave = !isLoading && isFilled && (!isEditing || isSomethingChanged);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!canSave) {
            return;
        }
        const config = {
            eventCode: trimmedEventCode,
            eventLinkDescription: trimmedDescription,
            chainTypeGuid,
            enabled,
        };
        if (!isEditing) {
            createLink(config);
            return;
        }
        if (!initialState) {
            return;
        }
        updateLink({ guid: initialState.guid, ...config });
    };
    return (React.createElement("form", { className: styles.root, noValidate: true, autoComplete: "off", onSubmit: handleSubmit },
        React.createElement(Typography, { className: styles.header, variant: "h4", component: "h2" }, isEditing ? 'Редактирование события связи' : 'Новое событие связи'),
        React.createElement(TextField, { className: styles.input, variant: "outlined", required: true, label: "\u041A\u043E\u0434 \u0441\u043E\u0431\u044B\u0442\u0438\u044F", value: eventCode, onChange: (event) => setEventCode(event.target.value) }),
        React.createElement(TextField, { className: styles.input, variant: "outlined", label: "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435", value: description, onChange: (event) => setDescription(event.target.value) }),
        React.createElement(TextField, { select: true, className: styles.input, variant: "outlined", required: true, label: "\u0422\u0438\u043F \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446. \u0446\u0435\u043F\u043E\u0447\u043A\u0438", 
            // Пока справочник грузится, MUI Select ругается на value без MenuItem.
            value: chainDescriptions.length ? chainTypeGuid : '', onChange: (event) => setChainTypeGuid(event.target.value) }, chainDescriptions.map((chain) => (React.createElement(MenuItem, { key: chain.guid, value: chain.guid }, chain.code)))),
        React.createElement(FormControlLabel, { className: styles.input, control: React.createElement(Checkbox, { color: "primary", checked: enabled, onChange: (event) => setEnabled(event.target.checked) }), label: "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E" }),
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Button, { type: "submit", variant: "contained", color: "primary", disabled: !canSave }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
            isEditing && initialState && (React.createElement(Box, { ml: 2 },
                React.createElement(ConfirmDeleteEventChainLink, { disabled: isLoading, onDelete: () => deleteLink(initialState.guid) }))))));
};
